import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface SideMenuLinkEntityParams {
  forward_url?: string;
  label: string;
}
export class SideMenuLinkEntity extends BaseEntityClass {
  forward_url?: string;
  label: string;
  constructor(params: SideMenuLinkEntityParams) {
    super();
    this.type = "side_menu_link";
    this.entity_version = 1;
    this.forward_url = params.forward_url;
    this.label = params.label;
  }
}
